<template>
  <div class="wrap-dashboard">
    <div class="main-content">
      <div class="wrap-content">
        <div class="welcome-container">
          <h1>Welcome,  {{ username }} !</h1>
        </div>
        <!-- <div class="top-title"> -->
        <!-- <div class="title-page">Welcome Back </div> -->
        <!-- <div class="title-page">Clearing and Settlement</div>
                    <img src="@/assets/logo_agi.png" alt="" v-show="role == 13" class="bagi" /> -->
        <!-- </div> -->
        <!-- <div class="top-menu">
                    <div class="filter">
                        <button class="btn-filter" @click="showToggle = !showToggle">Sort by Date: {{ form.startDate + " - " + form.endDate }}</button>
                        <div class="dropdown" v-show="showToggle">
                            <input
                                placeholder="Pilih tanggal awal"
                                type="text"
                                onfocus="(this.type='date')"
                                onblur="(this.type='text')"
                                id="start-date"
                                :max="today"
                                class="form-input"
                                v-model="form.startDate"
                            />
                            <input
                                placeholder="Pilih tanggal akhir"
                                type="text"
                                onfocus="(this.type='date')"
                                onblur="(this.type='text')"
                                id="start-date"
                                class="form-input"
                                v-model="form.endDate"
                                :min="form.startDate"
                                :max="today"
                                :disabled="form.startDate == ''"
                            />
                            <input type="submit" value="Apply" class="btn-primer" @click="filterDate" />
                        </div>
                        <div class="sort-pialang">
                            <select name="" id="" class="filter-select" v-model="clientType" @click="filterClienType">
                                <option value="" selected disabled>Client Type</option>
                                <option value="pc-pc">PC - PC</option>
                                <option value="mm-pc">MM - PC</option>
                                <option value="pc-mm">PC - MM</option>
                            </select>
                        </div>
                        <div class="sort-pialang">
                            <select name="" id="" class="filter-select" v-model="brokerCode" @click="filterBroker">
                                <option value="" selected disabled>Broker Code</option>
                                <option value="001">001 - ABI</option>
                            </select>
                        </div>
                        <div class="sort-bank" v-show="role != 13">
                            <select name="" id="" class="filter-select" v-model="bankCode" @click="filterBank">
                                <option value="" selected disabled>Bank Code</option>
                                <option value="037">BAGI</option>
                            </select>
                        </div>
                        <div class="reset-filter">
                            <button type="button" @click="resetFilter" v-show="form.endDate != '' || clientType != ''">Reset Filter</button>
                        </div>
                    </div>
                    <div class="wrap-excel">
                        <ExportExcel v-show="hideExcel" />
                        <button class="btn btn-filter" @click="toggleExcel = !toggleExcel">Download</button>
                        <div v-show="toggleExcel" class="dropdown-excel">
                            <input
                                placeholder="Pilih tanggal awal excel"
                                type="text"
                                onfocus="(this.type='date')"
                                onblur="(this.type='text')"
                                id="start-date"
                                :max="today"
                                class="form-input"
                                v-model="formExcel.startDate"
                            />
                            <input
                                placeholder="Pilih tanggal akhir"
                                type="text"
                                onfocus="(this.type='date')"
                                onblur="(this.type='text')"
                                id="start-date"
                                class="form-input"
                                v-model="formExcel.endDate"
                                :min="formExcel.startDate"
                                :max="today"
                                :disabled="formExcel.startDate == ''"
                                @input="inputToExcel"
                            />
                            <input type="submit" value="Apply" class="btn-primer" @click="tableToExcel" />
                        </div>
                    </div>
                </div>
                <div class="content">
                    <table id="testTable1">
                        <thead>
                            <tr id="top">
                                <th scope="col" rowspan="2" style="width: 70px">No</th>
                                <th scope="col" rowspan="2" style="width: 120px">Trade Matched Id</th>
                                <th scope="col" rowspan="2">TimeStamp</th>
                                <th scope="col" rowspan="2">Rate</th>
                                <th scope="col" colspan="8">Buyer</th>
                                <th scope="col" colspan="8">Seller</th>
                            </tr>
                            <tr>
                                <th scope="col">Order Id</th>
                                <th scope="col">Trade Id</th>
                                <th scope="col">VA Code</th>
                                <th scope="col">Weight (gr)</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Fee</th>
                                <th scope="col">Tax</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col">Order Id</th>
                                <th scope="col">Trade Id</th>
                                <th scope="col">VA Code</th>
                                <th scope="col">Weight (gr)</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Fee</th>
                                <th scope="col">Tax</th>
                                <th scope="col">Total Amount</th>
                            </tr>
                        </thead>
                        <tbody v-if="loadingData">
                            <tr>
                                <td class="text-center" colspan="20">
                                    <b-spinner label="Loading..."></b-spinner>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(data, i) in data" :key="i" v-show="data.length != 0">
                                <td data-label="No" style="border-right: 1px solid #ededed">
                                    {{ (currentPage - 1) * perPage + (i + 1) }}
                                </td>
                                <td data-label="Trade Match Id" style="border-right: 1px solid #ededed">
                                    {{ data._id.order_match_id }}
                                </td>
                                <td data-label="Time Stamp" style="border-right: 1px solid #ededed">
                                    {{ data.timestamp | formatDateTimeReal }}
                                </td>
                                <td data-label="Rate" style="border-right: 1px solid #ededed">
                                    <div v-if="data.type_client == 'PC-LP' || data.type_client == 'PC-CP'">
                                        Buy
                                        {{ data.direction[0] ? " Rp" + data.direction[0].payment_info.rate.toLocaleString() : "" }}
                                    </div>
                                    <div v-else-if="data.type_client == 'LP-PC' || data.type_client == 'CP-PC'">
                                        Sell
                                        {{ data.direction[1] ? " Rp" + data.direction[1].payment_info.rate.toLocaleString() : "" }}
                                    </div>
                                    <div v-else>-</div>
                                </td>
                                <td data-label="Order Id" class="description">
                                    {{ data.direction[0] ? data.direction[0].order_id : "-" }}
                                </td>
                                <td data-label="Remarks">
                                    <div v-show="data.direction[0].tradebuy">
                                        <span v-if="role == 1 || role == 6">
                                            <img src="../assets/cimb.png" alt="" class="icon-trade" v-show="data.direction[0].payment_info.bank_code == '022'" />
                                            <img src="../assets/bagi.png" alt="" class="icon-trade" v-show="data.direction[0].payment_info.bank_code == '037'" />
                                        </span>
                                        <span v-else>
                                            {{ data.direction[0].tradebuy[1] }}
                                        </span>
                                        <span>
                                            {{ " " + data.direction[0].tradebuy[0] + "-" }}
                                        </span>
                                        <span>{{ data.direction[0].tradebuy[2] }}</span>
                                    </div>
                                </td>
                                <td data-label="VA Code">
                                    {{ data.direction[0] ? data.direction[0].va_code : "" }}
                                </td>
                                <td data-label="weight">
                                    {{ data.direction[0].gold_info ? data.direction[0].gold_info.total_gram : "-" }}
                                </td>
                                <td data-label="Amount">
                                    <div>
                                        {{ data.direction[0] ? "IDR " + data.direction[0].payment_info.amount_idr.toLocaleString() : "-" }}
                                    </div>
                                    <div>
                                        {{ data.direction[0] ? "USD " + data.direction[0].payment_info.amount.toLocaleString() : "-" }}
                                    </div>
                                </td>
                                <td data-label="fee">
                                    <div>
                                        {{ data.direction[0].payment_info.fee_idr ? "IDR " + data.direction[0].payment_info.fee_idr : "IDR -" }}
                                    </div>
                                    <div>
                                        {{ data.direction[0] ? "USD " + data.direction[0].payment_info.fee : "-" }}
                                    </div>
                                </td>
                                <td data-label="tax">
                                    <div>
                                        {{ data.direction[0].payment_info.tax_idr ? "IDR " + data.direction[0].payment_info.tax_idr.toFixed(2) : "IDR -" }}
                                    </div>
                                    <div>
                                        {{ data.direction[0] ? "USD " + data.direction[0].payment_info.tax.toFixed(2) : "-" }}
                                    </div>
                                </td>

                                <td data-label="Total Amount" style="border-right: 1px solid #ededed">
                                    <div>
                                        {{ data.direction[0] ? "IDR " + data.direction[0].payment_info.payment_idr.toLocaleString() : "-" }}
                                    </div>
                                    <div>
                                        {{ data.direction[0] ? "USD " + data.direction[0].payment_info.payment_usd.toLocaleString() : "-" }}
                                    </div>
                                </td>
                                <td data-label="Order Id">
                                    {{ data.direction[1] ? data.direction[1].order_id : "-" }}
                                </td>
                                <td data-label="Remarks">
                                    <div v-show="data.direction[1] ? data.direction[1].tradeSell : '-'">
                                        <span v-if="role == 1 || role == 6">
                                            <img
                                                src="../assets/cimb.png"
                                                alt=""
                                                class="icon-trade"
                                                v-show="data.direction[1] ? data.direction[1].payment_info.bank_code == '022' : ''"
                                            />
                                            <img
                                                src="../assets/bagi.png"
                                                alt=""
                                                class="icon-trade"
                                                v-show="data.direction[1] ? data.direction[1].payment_info.bank_code == '037' : ''"
                                            />
                                        </span>
                                        <span v-else>{{ data.direction[1].tradeSell[1] }} </span>
                                        <span>
                                            {{ data.direction[1] ? " " + data.direction[1].tradeSell[0] + "-" : "" }}
                                        </span>
                                        <span>{{ data.direction[1] ? data.direction[1].tradeSell[2] : "-" }}</span>
                                    </div>
                                </td>
                                <td data-label="VA Code">
                                    {{ data.direction[1] ? data.direction[1].va_code : "" }}
                                </td>
                                <td data-label="weight">
                                    {{ data.direction[1].gold_info ? data.direction[1].gold_info.total_gram : "-" }}
                                </td>
                                <td data-label="Amount">
                                    <div>
                                        {{ data.direction[1] ? "IDR " + data.direction[1].payment_info.amount_idr.toLocaleString() : "-" }}
                                    </div>
                                    <div>
                                        {{ data.direction[1] ? "USD " + data.direction[1].payment_info.amount.toLocaleString() : "-" }}
                                    </div>
                                </td>
                                <td data-label="fee">
                                    <div>
                                        {{ data.direction[1].payment_info.fee_idr ? "IDR " + data.direction[1].payment_info.fee_idr.toFixed(2) : "IDR -" }}
                                    </div>
                                    <div>
                                        {{ data.direction[1] ? "USD " + data.direction[1].payment_info.fee.toFixed(2) : "-" }}
                                    </div>
                                </td>
                                <td data-label="Tax">
                                    <div>
                                        {{ data.direction[1].payment_info.tax_idr ? "IDR " + data.direction[1].payment_info.tax_idr.toFixed(2) : "IDR -" }}
                                    </div>
                                    <div>
                                        {{ data.direction[1] ? "USD " + data.direction[1].payment_info.tax.toFixed(2) : "-" }}
                                    </div>
                                </td>

                                <td data-label="Total Amount">
                                    <div>
                                        {{ data.direction[1] ? "IDR " + data.direction[1].payment_info.payment_idr.toLocaleString() : "-" }}
                                    </div>
                                    <div>
                                        {{ data.direction[1] ? "USD " + data.direction[1].payment_info.payment_usd.toLocaleString() : "-" }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-show="data.length == 0">
                                <td colspan="20">No Data Available</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="lengthData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="lengthData > 10"
                    ></b-pagination>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import ExportExcel from "../components/export/ExportExcel.vue";
import moment from "moment";
import * as XLSX from "xlsx";

export default {
  // components: {
  //   ExportExcel,
  // },
  data() {
    return {
      dataTransaction: [],
      pageOfItems: [],
      currentPage: 1,
      perPage: 10,
      lengthData: 1,
      trade_id: [],
      offset: 0,
      data: [],
      time_stamp: "",
      loadingData: false,
      today: "",
      role: "",
      form: {
        startDate: "",
        endDate: "",
      },
      formExcel: {
        startDate: "",
        endDate: "",
      },
      showToggle: false,
      toggleExcel: false,
      clientType: "",
      brokerCode: "001",
      bankCode: "037",
      dataExcel: [],
      hideExcel: false,
      liveTime: null,
      currentDate: null,
      dataClient: [],
      username: "",
    };
  },
  mounted() {
    this.username = sessionStorage.getItem("username");
    this.$store.dispatch("getTransaction", {
      startDate: this.startDate,
      endDate: this.endDate,
      currentPage: this.currentPage,
      perPage: this.perPage,
      clientType: this.clientType,
      bankCode: this.bankCode,
    });
    this.today = new Date().toISOString().split("T")[0];
    this.getData(
      this.currentPage,
      this.form.startDate,
      this.form.endDate,
      this.clientType,
      this.bankCode
    );
    this.role = sessionStorage.getItem("role");

    // axios.get("/v1/clearing/admin/get/list_client?exchange=jfx").then((res) => {
    //   this.dataClient = res.data.data;
    // });

    let date = new Date();
    this.currentDate = moment(date).format("dddd, DD MMMM YYYY");
  },
  created() {
    let like = this;
    setInterval(function () {
      let startDate = like.form.startDate;
      let endDate = like.form.endDate;
      like.getData(
        like.currentPage,
        startDate,
        endDate,
        like.clientType,
        like.bankCode
      );

      // location.reload();
    }, 60000);

    setInterval(() => {
      like.showLiveTime();
    }, 1000);
  },

  methods: {
    showLiveTime() {
      let date = new Date();
      this.liveTime = moment(date).format("HH:mm:ss");
    },
    inputToExcel() {
      var data = {
        startDate: this.formExcel.startDate,
        endDate: this.formExcel.endDate,
        bank_code: this.bankCode,
        client_type: this.clientType,
        offset: 0,
      };
      this.$emit("inputExcel", data);
      this.$root.$emit("inputExcel", data);
    },
    tableToExcel() {
      const table = document.getElementById("testTable");
      const wb = XLSX.utils.table_to_book(table);
      // var wscols = [{ wch: 20 }, { wch: 30 }, { wch: 40 }, { wch: 30 }, { wch: 10 }, { wch: 10 }];
      var wscols = [
        { wch: 5 }, //A
        { wch: 15 }, //B
        { wch: 20 }, //C
        { wch: 15 }, //D
        { wch: 10 }, //E
        { wch: 20 }, //F
        { wch: 20 }, //G
        { wch: 20 }, //H
        { wch: 10 }, //I
        { wch: 15 }, //J
        { wch: 10 }, //K
        { wch: 15 }, //L
        { wch: 10 }, //M
        { wch: 15 }, //N
        { wch: 10 }, //O
        { wch: 15 }, //P
        { wch: 10 }, //Q
        { wch: 10 }, //R
        { wch: 20 }, //S
        { wch: 20 }, //T
        { wch: 20 }, //U
        { wch: 10 }, //V
        { wch: 15 }, //W
        { wch: 10 }, //X
        { wch: 15 }, //Y
        { wch: 10 }, //Z
        { wch: 15 }, //AA
        { wch: 10 }, //AB
        { wch: 15 }, //AC
        { wch: 10 }, //AD
      ];
      wb["Sheets"]["Sheet1"]["!cols"] = wscols;
      delete wb["D1"];
      XLSX.utils.format_cell(wb["D1"]);
      let filename =
        "Data_transaksi " +
        this.formExcel.startDate +
        " - " +
        this.formExcel.endDate +
        ".xlsx";
      XLSX.writeFile(wb, filename, { cellText: true });
      this.toggleExcel = false;
    },
    tableToCsv() {
      var data = {
        startDate: this.formExcel.startDate,
        endDate: this.formExcel.endDate,
      };
      this.$emit("toggleDownload", data);
      this.$root.$emit("toggleDownload", data);
      this.toggleExcel = false;
    },

    toggle() {
      this.showToggle = !this.showToggle;
    },
    handlePageChange(value) {
      this.getData(
        value,
        this.form.startDate,
        this.form.endDate,
        this.clientType,
        this.bankCode
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    filterDate() {
      this.getData(
        this.currentPage,
        this.form.startDate,
        this.form.endDate,
        this.clientType,
        this.bankCode
      );
      this.showToggle = false;
    },
    filterBroker() {
      this.getData(
        this.currentPage,
        this.form.startDate,
        this.form.endDate,
        this.clientType,
        this.bankCode
      );
    },
    filterBank() {
      this.getData(
        this.currentPage,
        this.form.startDate,
        this.form.endDate,
        this.clientType,
        this.bankCode
      );
    },
    filterClienType() {
      this.getData(
        this.currentPage,
        this.form.startDate,
        this.form.endDate,
        this.clientType,
        this.bankCode
      );
    },
    resetFilter() {
      this.form.startDate = "";
      this.form.endDate = "";
      this.clientType = "";
      // this.bankCode = "";

      this.getData(
        this.currentPage,
        this.form.startDate,
        this.form.endDate,
        this.clientType,
        this.bankCode
      );
    },
    getData(value, startDate, endDate, clientType, bankCode) {
      let offset = (value - 1) * this.perPage;
      let url;
      let role = sessionStorage.getItem("role");
      if (role == 2) {
        url =
          "/v2/clearing/admin/abx/get/customer/transaction?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&offset=" +
          offset +
          "&limit=10&code=" +
          clientType +
          "&bank_code=" +
          bankCode;
      } else if (role == 6) {
        url =
          "/v2/clearing/admin/pos/get/customer/transaction?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&offset=" +
          offset +
          "&limit=10&code=" +
          clientType +
          "&bank_code=" +
          bankCode;
      } else if (role == 4) {
        url =
          "/v2/clearing/admin/bank/get/customer/transaction?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&offset=" +
          offset +
          "&limit=10&code=" +
          clientType +
          "&bank_code=" +
          bankCode;
      } else {
        url =
          "/v2/clearing/admin/get/customer/transaction?limit=10&code=" +
          clientType +
          "&bank_code=" +
          bankCode +
          "&startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&offset=" +
          offset;
      }

      this.loadingData = true;
      axios
        .get(url)
        .then((res) => {
          this.loadingData = false;
          this.data = res.data.data.body;
          this.lengthData = res.data.data.count;
          for (let i = 0; i < this.data.length; i++) {
            let trade;
            let tradeSell;
            let buy = {};
            let sell = {};

            if (this.data[i].direction.length < 2) {
              if (this.data[i].direction[0].direction == "sell") {
                tradeSell = this.data[i].direction[0].trade_id;
                this.data[i].direction[1] = this.data[i].direction[0];
                this.data[i].direction[1].tradeSell = tradeSell.split(";");
                this.data[i].direction[0] = {
                  date_pay: "2021-12-27T15:15:09.599Z",
                  direction: "buy",
                  order_id: "-",
                  order_match_id: "-",
                  total_amount_idr: 0,
                  trade_id: "0;037;0",
                  tradebuy: ["0", "037", "0"],
                  va_code: "-",
                  _id: "61c9760d46d2db0025758775",
                };
              } else {
                trade = this.data[i].direction[0].trade_id;
                this.data[i].direction[0].tradebuy = trade.split(";");
                this.data[i].direction[1] = "";
              }
            } else {
              if (this.data[i].direction[0].direction == "sell") {
                buy = this.data[i].direction[1];
                sell = this.data[i].direction[0];
              } else {
                buy = this.data[i].direction[0];
                sell = this.data[i].direction[1];
              }

              this.data[i].direction[1] = sell;
              tradeSell = this.data[i].direction[1].trade_id;
              this.data[i].direction[1].tradeSell = tradeSell.split(";");
              this.data[i].direction[0] = buy;
              trade = this.data[i].direction[0].trade_id;
              this.data[i].direction[0].tradebuy = trade.split(";");
              this.data[i].type_client =
                trade.slice(0, 2) + "-" + tradeSell.slice(0, 2);
            }
          }
        })
        .catch((error) => {
          this.loadingData = false;
          console.log(error);
        });
    },
  },
  computed: {
    rows() {
      return (this.currentPage - 1) * this.perPage;
    },
    transactionDatas() {
      return this.$store.state.kmiModule.dataTransaction;
    },
  },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.top-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4rem;
}

.bagi {
  height: 30px;
}

.top-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  background: #fff;
  box-shadow: 0px 5px 16px 1px rgb(0 0 0 / 15%);
  padding: 25px 20px;
  border-radius: 5px;
  position: relative;
}

.title-page {
  font-size: 26px;
  font-weight: bold;
}

.title-page div {
  font-size: 18px;
  font-weight: normal;
  margin-top: -20px;
}

/* .wrap-content {
  width: 98%;
  height: 100%;
  margin: 0 auto;
  padding: 20px 25px;
} */

.content {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.icon-trade {
  width: 25px;
}

table {
  display: block;
  overflow-x: auto;
}

.footer {
  background: var(--clr-primary);
  color: white;
  padding: 20px 47px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  height: 62px;
}

.form-input {
  border: solid 1px #ccc;
  height: 31px;
  padding: 5px 10px;
  border-radius: 5px;
  color: #aaa;
  font-size: 12px;
  margin-right: 10px;
}

.filter {
  display: flex;
  gap: 1rem;
  align-items: center;
  font-size: 12px;
  flex-wrap: wrap;
  position: relative;
  width: 48%;
}

.card {
  width: 314px;
  font-size: 14px;
  border-radius: 10px;
}

.card-header {
  padding: 1rem;
}

.buyer,
.seller,
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 12px;
  position: relative;
  left: 20px;
}

.title::before {
  content: "";
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--clr-scondary);
  left: -17px;
  top: 3px;
}

.buyer {
  margin-bottom: 20px;
}

.content-right {
  text-align: right;
}

.amount {
  font-weight: bold;
}

.btn-primer {
  background: var(--clr-scondary);
  border: none;
  color: #ffffff;
  padding: 5px 20px;
  font-size: 13px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.btn-primer:hover,
.btn-filter:hover {
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
  transform: translateY(-1px);
}

.btn-filter {
  border: none;
  background: #fff;
  color: var(--clr-scondary);
  padding: 5px 20px;
  font-size: 13px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.reset-filter button {
  border: none;
  color: #fff;
  background: #f75676;
  padding: 5px 10px;
  font-size: 13px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  cursor: pointer;
}

.btn-filter:focus {
  outline: 1px solid;
}

.description {
  text-align: left !important;
}

.sort-date {
  position: relative;
}

/* .wrap-excel {
  position: relative;
} */

.filter-select {
  border: none;
  background: #fff;
  color: var(--clr-scondary);
  padding: 5px;
  font-size: 13px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.dropdown {
  position: absolute;
  left: 0;
  top: 2.5rem;
  background: #fff;
  padding: 10px 20px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  border-radius: 5px;
  width: 29.1rem;
}

.dropdown-excel {
  background: #fff;
  padding: 10px 20px;
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  border-radius: 5px;
  right: 18px;
  position: absolute;
  top: 5.5rem;
}

.excel {
  top: 58px;
}

input:disabled {
  cursor: not-allowed;
}

.welcome-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Sesuaikan dengan kebutuhan */
}

h1 {
  text-align: center;
}
</style>

